import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const PageHero = ({ eyebrow, title, desc, testId }) => (
  <section className="relative grain overflow-hidden bg-[#0B192C] pt-[76px]">
    <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[380px] w-[760px] rounded-full bg-amber-500/12 blur-[130px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24">
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="text-xs font-bold uppercase tracking-[0.24em] text-amber-400"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        data-testid={testId}
        initial={{ opacity: 0, y: 26 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
        className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.1] text-white"
      >
        {title}
      </motion.h1>
      {desc && (
        <motion.p
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.22, ease: EASE }}
          className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-300"
        >
          {desc}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHero;
